import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=63af7c7c&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63af7c7c')) {
      api.createRecord('63af7c7c', component.options)
    } else {
      api.reload('63af7c7c', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=63af7c7c&", function () {
      api.rerender('63af7c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4Ge0Wfex2jxde/JS/comp/CurrentYear.vue"
export default component.exports